import React, { Component } from 'react';
import { Table, Tag, Tooltip } from 'antd';
import NumberFormat from 'react-number-format';
import { renderReceiptStatus, renderReceiptRefundStatus, renderPaymentMethod, isValidDate, stripHtml, renderMoney } from '@/utils/helpers';
import TextTruncate from 'react-text-truncate';
import HtmlParser from 'react-html-parser';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { getReceiptCollectionPurposeLabel } from '@/utils/receiptCollectionResult';
import { checkPermission } from '@/utils/permission';
import ReceiptContentCell from '@/components/receipts/ReceiptContentCell';

class CustomerReceiptsTable extends Component {

    columns = [
        {
            title: 'STT',
            key: 'index',
            width: '40px',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Mã phiếu',
            dataIndex: 'code',
            key: 'code',
            width: '100px',
            render: (text, record) => {
                const canViewDetail = checkPermission('receipt', 'detail')
                    && typeof this.props.onViewReceipt === 'function';
                if (!canViewDetail) return text;

                return <Tooltip title="Xem chi tiết phiếu" placement="right">
                    <span className="color-primary item-action-btn" onClick={() => this.props.onViewReceipt(record.id)}>
                        {text}
                    </span>
                </Tooltip>;
            },
        },
        {
            title: 'Ngày thu',
            dataIndex: 'payment_at',
            key: 'payment_at',
            render: (text, record) => {
                if (text && text !== '') {
                    return (
                        <>{isValidDate(text, false)}</>
                    )
                } else {
                    return (<Tag></Tag>)
                }
            }
        },
        {
            title: 'Tổng',
            dataIndex: 'total_amount',
            key: 'total_amount',
            render: (text, record) => (
                <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
            )
        },
        {
            title: 'Ưu đãi',
            dataIndex: 'special_discount',
            key: 'special_discount',
            render: (text, record) => (
                <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
            )
        },
        {
            title: 'Doanh số',
            dataIndex: 'adjusted_sales',
            key: 'adjusted_sales',
            render: (text, record) => (
                <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
            )
        },
        {
            title: 'Số tiền thu',
            dataIndex: 'amount_paid',
            key: 'amount_paid',
            render: (text) => (
                <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
            ),
        },
        {
            title: 'Tổng đã thu',
            dataIndex: 'total_amount_paid',
            key: 'total_amount_paid',
            render: (text) => (
                <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
            ),
        },
        {
            title: (
                <span>
                    Công nợ{' '}
                    <Tooltip title="Công nợ ngay sau khi ghi nhận phiếu thu này. Các khoản thu, hoàn tiền hoặc thay đổi dịch vụ sau đó có thể làm số này khác công nợ hiện tại của khách.">
                        <QuestionCircleOutlined style={{ color: '#8c8c8c', cursor: 'help' }} />
                    </Tooltip>
                </span>
            ),
            dataIndex: 'remaining_debt',
            key: 'remaining_debt',
            render: (text) => (
                <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
            ),
        },
        {
            title: 'Nội dung thu',
            key: 'receipt_content',
            width: '220px',
            render: (_, record) => <ReceiptContentCell
                receipt={record}
                canViewDetail={checkPermission('receipt', 'detail')}
                onViewReceipt={this.props.onViewReceipt}
            />,
        },
        {
            title: 'Nghiệp vụ thu',
            dataIndex: 'collection_purpose',
            key: 'collection_purpose',
            width: '180px',
            render: value => <Tag color={value === 'DEPOSIT' ? 'gold' : 'blue'}>
                {getReceiptCollectionPurposeLabel(value)}
            </Tag>,
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            key: 'status',
            width: '120px',
            render: (text, record) => {
                return (
                    <>
                        {renderReceiptStatus(text)}
                        {renderReceiptRefundStatus(record?.refund_summary?.status)}
                    </>
                )
            }
        },
        {
            title: 'Hình thức thu',
            dataIndex: 'payment_method',
            key: 'payment_method',
            render: (text, record) => {
                return (
                    <>{(record.payment_breakdowns || record.paymentBreakdowns || []).length
                        ? (record.payment_breakdowns || record.paymentBreakdowns).map(row => <div key={row.id || row.payment_method}>
                            {renderPaymentMethod(row.payment_method)} <strong>{renderMoney(row.amount)}</strong>
                        </div>) : renderPaymentMethod(text)}</>
                )
            }
        },
        {
            title: 'Ghi chú',
            dataIndex: 'note',
            key: 'note',
            width: '200px',
            render: (text, record) => {
                return (
                    <div style={{ wordBreak: "break-word" }}>
                        <Tooltip title={HtmlParser(text)} placement="topLeft">
                            <TextTruncate line={1} truncateText="…" text={stripHtml(text)} />
                        </Tooltip>
                    </div>
                )
            }
        }
    ];


    render() {

        return (
            <>
                <Table
                    size='small'
                    rowKey="id"
                    columns={this.columns}
                    dataSource={this.props.data ?? []}
                    pagination={false}
                    locale={{ emptyText: "Chưa có dữ liệu" }}
                    scroll={{
                        x: 'max-content'
                    }}
                />
            </>
        );
    }
}

export default CustomerReceiptsTable;
